import { render } from "./EditProduct.vue?vue&type=template&id=400996e2"
import script from "./EditProduct.vue?vue&type=script&lang=js"
export * from "./EditProduct.vue?vue&type=script&lang=js"
script.render = render

export default script